import Vue from 'vue';
// 引入基础框架
import App from 'bjxy-component/app/index.vue';
// 初始化基础的路由
import baseRouter from 'bjxy-common/baseRouter';
// 初始化基础的Store
import baseStore from 'bjxy-common/baseStore';
// 基础网络操作
import ajax from 'bjxy-common/network';
// Vue 基础方法扩展
import vuePlugin from 'bjxy-common/vuePlugin';
// 页面路由
import router from './router';
// 页面数据仓库
import pageStore from './store';
// 页面数据上报
import reporter from 'bjxy-component/reporter';
//js/css reset
import 'bjxy-common/helper/jsReset';
import 'bjxy-common/base.css';
import 'bjxy-common';
import getWXUnionid from 'bjxy-common/xyHelper/getWXUnionid'
import getQueryString from 'bjxy-common/helper/getQueryString'
if(getQueryString('partnerName')==='ZHONGXINAPI'){
  import('./style/ZHONGXINAPI.less')
}else if(getQueryString('partnerName')==='ZHONGXINAPI2'){
  import('./style/ZHONGXINAPI2.less')
} else if(getQueryString('partnerName')==='ZHAOLIAN_JYD') {
  import('./style/ZHONGXINAPI2.less')
}else{
  getWXUnionid()
}

let store = baseStore(pageStore);
let http = ajax(store);
baseRouter(router, store);
window.ajaxHost = location.origin;
// window.ajaxHost = 'http://cardloan.xiaoying.com';


// 根据业务决定 vue 初始化条件,在app 内嵌页的话走 jsBridge，如果用不到，或者在浏览器里面就不需要了
// 如果要根据 config 接口返回值确定如何初始化，可以先使用 ajax 返回的http

  Vue.use(vuePlugin);
  new Vue({
    el: '#app',
    router,
    store,
    render(createElement) {
      return createElement(App);
    },
    methods:{
      report: reporter({softid:5,cmdid:55059})
    }
  });


